import { render, staticRenderFns } from "./stopSellingTemplate.vue?vue&type=template&id=31f4caf8"
import script from "./stopSellingTemplate.vue?vue&type=script&lang=js"
export * from "./stopSellingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports